<template>
  <div>
    Line redirect
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "LineCallback",
});
</script>

<style></style>
